import { EducationLevel, EducationLevelGroup } from "@domain/EducationLevel";
import { RewardCursor } from "@domain/User";
import { NonEmptyArray } from "@helpers/array.helper";

export const FIRESTORE_BASE_PATH = "exercisers/apexerciserhomophones";
export const REGULAR_SEQUENCE_LENGTH = 6;
export const AUTHENTICATION_TIMEOUT_MILLIS = 4200;
export const REWARD_CURSOR_PROGRESSION_DEFAULT_ORDER: RewardCursor[] = ["turtle", "bee", "dino", "bird", "unicorn", "chicken", "frog", "fish"];
export const ELEMENTARY_SCHOOL_GRADE = [3, 4, 5, 6];
export const HIGH_SCHOOL_GRADE = [7, 8, 9, 10, 11];

export const EDUCATION_LEVEL_GROUPS: NonEmptyArray<EducationLevelGroup> = [
  {
    id: "elementary-3-4",
    name: "Primaire 3-4",
    educationLevels: [EducationLevel.ELEMENTARY_3, EducationLevel.ELEMENTARY_4],
    numberOfHomophoneGroups: { min: 1, max: 3 },
    matchingUserSchoolGrades: [3, 4],
  },
  {
    id: "elementary-5-6",
    name: "Primaire 5-6",
    educationLevels: [EducationLevel.ELEMENTARY_5, EducationLevel.ELEMENTARY_6],
    numberOfHomophoneGroups: { min: 1, max: 3 },
    matchingUserSchoolGrades: [5, 6],
  },
  {
    id: "highSchool-1-2",
    name: "Secondaire 1-2",
    educationLevels: [EducationLevel.HIGH_SCHOOL_1, EducationLevel.HIGH_SCHOOL_2],
    numberOfHomophoneGroups: { min: 3, max: 3 },
    matchingUserSchoolGrades: [7, 8],
  },
  {
    id: "highSchool-3-5",
    name: "Secondaire 3-5",
    educationLevels: [EducationLevel.HIGH_SCHOOL_3, EducationLevel.HIGH_SCHOOL_4, EducationLevel.HIGH_SCHOOL_5],
    numberOfHomophoneGroups: { min: 3, max: 3 },
    matchingUserSchoolGrades: [9, 10, 11],
  },
];
